<script setup></script>

<template>
  <div class="flex min-h-screen flex-col font-main text-base text-tarawera-900">
    <slot />
  </div>
  <Notifications />
</template>
